import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {useHistory} from "react-router-dom";
import {getUrlString, getUrlValue} from "../../../utils/CommonUtils";
import TableLoader from "@components/Loaders/tableLoader";
import {Table} from "antd";
import {getBetList} from "@actions/betsActions";
import {BetStatus} from "@constants/Enums";
import moment from "moment-timezone";
import classNames from "classnames";
import BetsFilter from "@components/BetsFilter/BetsFilter";
import {setDoneMsg, setErrorMsg} from "@actions/alertAction";
import {copyLabel, getFormattedBody} from "@services/TableServices";
import {TableProfit} from "@components/TableProfit/TableProfit";

const keysOfDate = ["dateFrom", "dateTo"]


function Bets({intl, loading, getBetList, bets, setDoneMsg, setErrorMsg}) {
    let history = useHistory()
    let search = history && history.location && history.location.search

    const [totalPages, setTotalPages] = useState(0)
    const [limit, setLimit] = useState(+getUrlValue(search).limit || 10)
    const [page, setPage] = useState(+getUrlValue(search).page || 1)
    const [profit, setProfit] = useState({})
    const [showFilter, setShowFilter] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState("")
    const columns = [
        {
            title: intl.formatMessage({id: "client"}),
            dataIndex: 'clientName',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`${BetStatus[record.betStatus] + "_bg"}`}>{record.clientName}</div>
            }
        },
        {
            title: intl.formatMessage({id: "player"}),
            dataIndex: 'playerName',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`${BetStatus[record.betStatus] + "_bg"}`}>{record.playerName}</div>
            }
        },
        {
            title: intl.formatMessage({id: "date"}),
            dataIndex: 'createDate',
            width: "fit-content",
            render: (text, record) => {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                return <div
                    className={`${BetStatus[record.betStatus] + "_bg"}`}>{moment(record.createDate).tz(timeZone).format("DD/MM/YYYY  HH:mm:ss")}</div>
            }

        },
        {
            title: intl.formatMessage({id: "status"}),
            dataIndex: 'betStatus',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`${BetStatus[record.betStatus] + "_bg"} ${BetStatus[record.betStatus]}`}>
                    <FormattedMessage
                        id={BetStatus[record.betStatus]}/></div>
            }

        },
        {
            title: intl.formatMessage({id: "game_id"}),
            dataIndex: 'gameId',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`copyable ${BetStatus[record.betStatus] + "_bg"}`} onDoubleClick={(e) => {
                    copyLabel(e, record.gameId)
                        .then(() => {
                            setDoneMsg("text_is_copied")
                        }).catch(() => {
                        setErrorMsg("something_wrong_the_text_is_not_copied")
                    })
                }}>{record.gameId}</div>
            }
        },

        {
            title: intl.formatMessage({id: "session"}),
            dataIndex: 'sessionId',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`copyable ${BetStatus[record.betStatus] + "_bg"}`} onDoubleClick={(e) => {
                    copyLabel(e, record.sessionId)
                        .then(() => {
                            setDoneMsg("text_is_copied")
                        }).catch(() => {
                        setErrorMsg("something_wrong_the_text_is_not_copied")
                    })
                }}>{record.sessionId}</div>
            }
        },
        {
            title: intl.formatMessage({id: "win"}),
            dataIndex: 'win',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`${BetStatus[record.betStatus] + "_bg"}`}>{record.win} </div>
            }
        },
        {
            title: intl.formatMessage({id: "stake"}),
            dataIndex: 'stake',
            width: "fit-content",
            render: (text, record) => {
                return <div className={`${BetStatus[record.betStatus] + "_bg"}`}>{record.stake} </div>
            }
        },
    ];


    const fetchBets = (isFirst) => {
        let initialForm = getUrlValue(search, keysOfDate)
        initialForm = {
            ...initialForm,
            page: initialForm.page || page,
            limit: initialForm.limit || limit,
            playerNameLike: selectedPlayer ? selectedPlayer : (initialForm.playerNameLike || "")
        }

        if (isFirst) {
            const {params} = getUrlString(initialForm)
            if (Array.from(params).length === 2 && params.has("page") && params.has("limit") && params.get("page") == 1 && params.get("limit") == 10) {
                initialForm = {
                    ...initialForm,
                    dateFrom: moment(new Date().setDate(new Date().getDate() - 3)).endOf('day').utc().format(),
                    dateTo: moment(new Date()).utc().format()
                }
            }

        }
        if (Object.keys(initialForm).length) {
            const {params} = getUrlString(initialForm)
            getBetList(initialForm)
            isFirst ? history.replace({search: params.toString()}) : history.push({search: params.toString()})
        }
    }

    useEffect(() => {
        fetchBets(true)
    }, [])

    useEffect(() => {
        return history.listen((location, action) => {
            const loc = location.search
            if (loc) {
                const initialForm = getUrlValue(loc, keysOfDate)
                getBetList(getFormattedBody(initialForm))
                setPage(+initialForm.page || page)
                setLimit(+initialForm.limit || limit)
            }
        })
    }, [history])

    useEffect(() => {
        if (selectedPlayer) {
            const initialForm = getUrlValue(search)
            const {params} = getUrlString({
                clientId: initialForm.clientId,
                page: 1,
                limit,
                playerNameLike: selectedPlayer
            })

            setPage(1)
            history.push({search: params.toString()})
            setSelectedPlayer("")
        }

    }, [selectedPlayer])


    useEffect(() => {
        if (bets && bets.items) {
            setTotalPages(bets.total);
            setProfit(bets.profit || {});
        }
    }, [bets]);

    const handleTablePaginate = (changedPage, changedLimit) => {
        let newPage = 1;
        if (limit === changedLimit) newPage = changedPage
        setPage(newPage);
        setLimit(changedLimit)
        const initialForm = getUrlValue(search, keysOfDate)
        const {params} = getUrlString({...initialForm, page: newPage, limit: changedLimit})
        history.push({search: params.toString()})

    }

    return (
        <div className="content bets">
            <div className="titleArea">
                <div className="titleArea--title"><FormattedMessage id='bets'/></div>
                <button className={classNames("filterBtn", {show: showFilter})}
                        onClick={() => setShowFilter(prev => !prev)}>
                    <div className="icon"/>
                    <FormattedMessage id='filter'/>
                </button>
            </div>
            <BetsFilter limit={limit}
                        setPage={setPage}
                        showFilter={showFilter}
                        selectedPlayer={selectedPlayer}
            />
            <div className="bets">
                <div className="mainTable">
                    {loading._bet_list ? <TableLoader count={limit} column={8} icon={false} drag={false} actions={0}/> :
                        <div>
                            <Table dataSource={bets.items || []}
                                   columns={columns}
                                   rowKey="id"
                                   rowClassName={(record) => `${BetStatus[record.betStatus] + "_bg"}`}
                                   scroll={{x: '100%'}}
                                   pagination={false}
                            />
                            <TableProfit profit={profit}
                                         totalPages={totalPages}
                                         handleTablePaginate={handleTablePaginate}
                                         limit={limit}
                                         page={page}
                                         intl={intl}/>
                        </div>
                    }
                </div>

            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        bets: state.betsList,
        loading: state.loading
    }
}

const mapDispatchToProps = {
    getBetList,
    setErrorMsg,
    setDoneMsg
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Bets));